import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable react/prop-types */

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { ChevronRight16 } from '@carbon/icons-react';
import cx from 'classnames';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var useNestedRowExpander = function useNestedRowExpander(hooks) {
  var visibleColumns = function visibleColumns(columns) {
    var expanderColumn = {
      id: 'expander',
      Cell: function Cell(_ref) {
        var _cx;

        var row = _ref.row;
        return row.canExpand && /*#__PURE__*/React.createElement("span", row.getToggleRowExpandedProps(), /*#__PURE__*/React.createElement(ChevronRight16, {
          className: cx("".concat(blockClass, "__expander-icon"), (_cx = {}, _defineProperty(_cx, "".concat(blockClass, "__expander-icon--not-open"), !row.isExpanded), _defineProperty(_cx, "".concat(blockClass, "__expander-icon--open"), row.isExpanded), _cx))
        }));
      },
      width: 48,
      disableResizing: true,
      disableSortBy: true,
      Header: ''
    };
    return [expanderColumn].concat(_toConsumableArray(columns));
  };

  hooks.visibleColumns.push(visibleColumns);
};

export default useNestedRowExpander;